import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useGet from "../../services/hooks/useGet";
import usePut from "../../services/hooks/usePut";
import { apiEndpoints } from "../../shared/constants/api-constant";
import {
  AlertType,
  DynamicPages,
  SPActionType,
} from "../../shared/constants/enums";
import { Heading } from "../../shared/ReusableComponents";
import IconButton from "../../shared/ReusableComponents/IconButton";
import ReactTable from "../../shared/ReusableComponents/ReactTable";
import { hideLoader, showLoader } from "../../store/currentPreferencesSlice";
import { toast } from "../../store/toastSlice";
import { trackNotesProgress } from "../../store/userNotesSlice";

export const Shiftplanner = () => {
  const [data, setData] = useState<any[]>([]);
  const [prevData, setPrevData] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(true);
  const dispatch = useDispatch();
  const {
    data: spRes,
    loading: spLoading,
    getService: SpGetService,
  } = useGet();
  const { data: putResponse, putService } = usePut();
  const initialForm = {
    id: 1,
    bed: "",
    name: "",
    "08:00-09:00": "",
    "09:00-10:00": "",
    "10:00-11:00": "",
    "11:00-12:00": "",
    "12:00-13:00": "",
    "13:00-14:00": "",
    "14:00-15:00": "",
    "15:00-16:00": "",
    comments: "",
  };

  const columns: any[] = [
    {
      headerName: "Bed #",
      field: "bed",
      width: "180px",
    },
    {
      headerName: "Patient Name",
      field: "name",
      width: "180px",
    },
    {
      headerName: "08:00-09:00",
      field: "08:00-09:00",
      width: "180px",
    },
    {
      headerName: "09:00-10:00",
      field: "09:00-10:00",
      width: "180px",
    },
    {
      headerName: "10:00-11:00",
      field: "10:00-11:00",
      width: "180px",
    },
    {
      headerName: "11:00-12:00",
      field: "11:00-12:00",
      width: "180px",
    },
    {
      headerName: "12:00-13:00",
      field: "12:00-13:00",
      width: "180px",
    },
    {
      headerName: "13:00-14:00",
      field: "13:00-14:00",
      width: "180px",
    },
    {
      headerName: "14:00-15:00",
      field: "14:00-15:00",
      width: "180px",
    },
    {
      headerName: "15:00-16:00",
      field: "15:00-16:00",
      width: "180px",
    },
    {
      field: "comments",
      headerName: "Comments",
      width: "250px",
    },
  ];

  const onChange = (value: string, field: string, index: number) => {
    const updatedData = [...data];
    updatedData[index] = {
      ...updatedData[index],
      [field]: value,
    };
    setData(updatedData);
    setIsEdit(false);
  };

  const addNew = () => {
    if (!Array.isArray(data)) {
      setData([{ ...initialForm }]);
    } else if (data.length >= 10) return;
    else {
      const newRow = {
        ...initialForm,
        id: data.length + 1,
      };
      setData((prev) => [...prev, newRow]);
    }
  };

  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(prevData)) {
      dispatch(trackNotesProgress(true));
    } else dispatch(trackNotesProgress(false));
  }, [data]);

  const onSubmitHanlder = (
    type: SPActionType = SPActionType.SUBMIT,
    index: number
  ) => {
    switch (type) {
      case SPActionType.CANCEL:
        setIsEdit(true);
        setData(prevData);
        break;
      case SPActionType.EDIT:
        setIsEdit(false);
        break;
      case SPActionType.DELETE:
        setData((prev) => prev.filter((_, i) => i !== index));
        break;
      default:
        setIsEdit(true);
        const removeEmptyRows = (arr: any[]) => {
          return arr.filter((obj) =>
            Object.entries(obj)
              .filter(([key]) => key !== "id")
              .some(([, value]) => value && value.toString().trim() !== "")
          );
        };
        const payload = removeEmptyRows(data);
        putService(apiEndpoints.DYNAMIC_PAGES, {
          dynamicPagesId: DynamicPages.SHIFT_PLANNER,
          dataJson: JSON.stringify(payload),
        });
        break;
    }
  };

  const getApi = () => {
    SpGetService(`${apiEndpoints.DYNAMIC_PAGES}/${DynamicPages.SHIFT_PLANNER}`);
  };

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    const shiftPlannerData = Array.isArray(JSON.parse(spRes))
      ? JSON.parse(spRes)
      : prevData;
    setData(shiftPlannerData);
    setPrevData(shiftPlannerData);
  }, [spRes]);

  useEffect(() => {
    spLoading && dispatch(showLoader());
    !spLoading && dispatch(hideLoader());
  }, [spLoading]);

  useEffect(() => {
    if (putResponse) {
      getApi();
      dispatch(
        toast({
          message: `Notes successfully ${
            prevData.length === 0 ? "Saved" : "Updated"
          }`,
          type: AlertType.SUCCESS,
        })
      );
    }
  }, [putResponse]);

  return (
    <Box className="shiftPlanner">
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Heading isBold={true} text="Shift Planner" classes="mb-1" type="h5" />
        {!isEdit && (
          <IconButton
            variant="text"
            onClick={(e) => addNew()}
            text={<Heading text="Add New" isBold />}
            icon={<span className="material-symbols-outlined">add_circle</span>}
          />
        )}
      </Box>
      <ReactTable
        isEdit={isEdit}
        columns={columns}
        tableData={data}
        onInputChange={onChange}
        onButtonHandler={onSubmitHanlder}
      />
    </Box>
  );
};
